import "./styles.css";
import Header from "./components/header";
import Home from "./components/home";
import About from "./components/about";
import Typeform from "./components/typeform";
import Footer from "./components/footer";
import Faqs from "./components/faq";
import Info from "./components/info";
import Services from "./components/services";
import Agents from "./components/agents";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import CookieConsent from "react-cookie-consent";
import Cookie from "./components/cookie";
import Privacy from "./components/privacy";
import { useLocation } from "react-router-dom";

function App() {
  const [showBanner, setShowBanner] = useState(true);

  const resetConsent = () => {
    Cookies.remove("CookieConsent");
    setShowBanner(false);
    setTimeout(() => setShowBanner(true), 50);
  };

function ScrollHandler() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return null;
}

  return (
    <>
      <Router>
        <Header />
        <ScrollHandler />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/form" element={<Typeform />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/info" element={<Info />} />
          <Route path="/services" element={<Services />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/cookie-policy" element={<Cookie />} />
          <Route path="/privacy-policy" element={<Privacy />} />
        </Routes>
      </Router>

      {showBanner && (
        <CookieConsent
          location="bottom"
          cookieName="CookieConsent"
          enableDeclineButton
          buttonText="Accept All"
          declineButtonText="Decline"
          style={{
            background: "#181b1e ",
            color: "#ccc",
            textAlign: "center",
            fontSize: "0.8rem",
            padding: "1rem 2rem",
            justifyContent: "center",
            width: "90%",
            margin: "2rem 5rem",
            border : "2px solid #666",
          }}
          buttonStyle={{
            border: "2px solid #42cfc6",
            background: "#42cfc6",
            color: "#000",
            padding: "0.5rem 1.5rem",
            margin: "0.5rem",
            borderRadius: "6px",
            fontWeight: "600",
            cursor: "pointer",
          }}
          declineButtonStyle={{
            border: "2px solid #42cfc6",
            background: "#42cfc6",
            color: "#000",
            padding: "0.5rem 1.5rem",
            margin: "0.5rem",
            borderRadius: "6px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
  We use cookies to enhance your browsing experience, provide analytics on site usage, and help us improve our services.  
  By clicking “Accept All”, you agree to the use of all cookies.  
  Click “Only Necessary” to allow essential cookies only, or “Decline” to disable optional cookies.  
  For more details, please review our Privacy Policy.
        </CookieConsent>
      )}

      <Footer onResetConsent={resetConsent} />
    </>
  );
}

export default App;
